export const PASSWORD_REGEX =
    /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!£$%^&*()[\]@#<>?])[A-Za-z\d@$.\/\\?><;:{[}\]'"*&^%#`~,|!%*?&_\)\(-]{10,}$/;

export const PASSWORD_REGEX_LIST = [
    'Minimum of 10 characters',
    'Include at least 1 lowercase character (a - z)',
    'Include at least 1 uppercase character (A - Z)',
    'Include at least 1 number (0 - 9)',
    'Include at least 1 special character (!£$%^&*()[]@#<>?)',
];

export const PASSWORD_REGEX_MESSAGE = `
  Your password must be a minimum of 10 characters and
  include at least 1 uppercase letter, 1 lowercase letter,
  1 digit and 1 special character.`;
